import { captureRemixErrorBoundaryError, withSentry } from "@sentry/remix";
import {
  isRouteErrorResponse,
  Link,
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useRouteError,
} from "@remix-run/react";
import tailwindStylesHref from "./tailwind.css?url";
import { Button } from "./components/ui/button";
import { get500ErrorMessage } from "./utils";
import { ClientOnly } from "remix-utils/client-only";
import { LinksFunction } from "@remix-run/node";

export const links: LinksFunction = () => [
  { rel: "stylesheet", href: tailwindStylesHref },
  {
    rel: "icon",
    href: "/favicon.ico",
    type: "image/x-icon",
  },
];

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en" className="dark">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body>
        <div className="flex min-h-screen w-full flex-col">
          {children}
          <ScrollRestoration />
          <Scripts />
        </div>
        {/* <footer className="py-4 text-center text-sm text-gray-500">
          &copy; Copyright {new Date().getFullYear()} Jon Hester
        </footer> */}
      </body>
    </html>
  );
}

export function ErrorBoundary() {
  const error = useRouteError();
  const isRouteError = isRouteErrorResponse(error);
  const isNotFound = isRouteError && error.status === 404;
  const serverError = get500ErrorMessage();
  captureRemixErrorBoundaryError(error);
  return (
    <ClientOnly>
      {() => (
        <div className="flex min-h-screen w-full flex-col mt-20 px-4 max-w-md mx-auto">
          <div className="">
            {isRouteError && (
              <p className="text-base font-semibold">{error.status}</p>
            )}
            <h1 className="mt-4 text-3xl font-bold tracking-tightsm:text-5xl">
              {isNotFound ? "Not Found" : serverError.title}
            </h1>
            {!isNotFound && serverError.gif && (
              <div className="w-full pt-6">
                <img src={serverError.gif} alt="Server Error" />
              </div>
            )}

            <p className="mt-6 text-left">
              {isNotFound
                ? "The page you are looking for does not exist."
                : serverError.message}

              {/* {isRouteErrorResponse(error)
        ? `${error.statusText}`
        : error instanceof Error
        ? error.message
        : "Unknown Error"} */}
            </p>

            <div className="mt-10 flex items-center justify-center gap-x-6">
              <Button asChild type="button">
                <Link to={`/`}>Go back home</Link>
              </Button>
            </div>
          </div>
        </div>
      )}
    </ClientOnly>
  );
}

function App() {
  return <Outlet />;
}

export default withSentry(App);
